//
//  src/components/wall/Wall.js
//
import React from "react";
import './Wall.css'


//
//  ink[s]
//
function importAll(r) { return r.keys().map(r); }
const Inks = importAll( require.context('../../images/gallery/', false, /\.(webp)$/) );


//
//  ink[s] image[s]
//
const InksImages = Inks.map((Ink) =>
    <InksImagesImage key={Ink} src={Ink} />
);


//
//  ink[s] image[s] image
//
function InksImagesImage(props) {
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [hasError, setHasError] = React.useState(false);
    
    let image_alt = props.src.split('.')[0].split('/')[3];
    //let image_size        = props.src.split('.')[1].split('/')[0];
    //let image_size_width  = image_size.split('x')[0];
    //let image_size_height = image_size.split('x')[1];
    
    const [showPlaceholder, setShowPlaceholder] = React.useState(true);
    
    React.useEffect(() => {
        if (isLoaded) {
            // Small delay to allow image to render, then fade out placeholder
            const timer = setTimeout(() => setShowPlaceholder(false), 100);
            return () => clearTimeout(timer);
        }
    }, [isLoaded]);
    
    return (
        <div className="image-wrapper">
            {showPlaceholder && !hasError && (
                <div className={`image-placeholder ${isLoaded ? 'fade-out' : ''}`} />
            )}
            <img
                className={`wall-image ${isLoaded ? 'loaded' : ''}`}
                src={props.src}
                alt={image_alt}
                height="800"
                width="100"
                loading="lazy"
                onLoad={() => setIsLoaded(true)}
                onError={() => setHasError(true)}
            />
        </div>
    );
}


//
//  wall
//
export default class Wall extends React.Component {
    render() {
        return (
            <>
                <section className="wall">
                    <div className="container">
                        {InksImages}
                    </div>
                </section>
            </>
        );
    }
}
